import { useState, useCallback } from 'react';

export const useFileUpload = (maxFiles = 3) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const handleDrop = useCallback((acceptedFiles) => {
        setUploadedFiles(prevFiles => {
            const totalFiles = acceptedFiles.length + prevFiles.length;
            
            if (totalFiles > maxFiles) {
                return prevFiles;
            }
            
            const hasDuplicates = prevFiles.some(existingFile =>
                acceptedFiles.some(newFile => newFile.name === existingFile.name)
            );
            
            if (hasDuplicates) {
                return prevFiles;
            }
            
            return [...prevFiles, ...acceptedFiles];
        });
    }, [maxFiles]);

    const removeFile = useCallback((fileName) => {
        setUploadedFiles(prevFiles => prevFiles.filter(file => file.name !== fileName));
    }, []);

    const clearFiles = useCallback(() => {
        setUploadedFiles([]);
    }, []);

    return {
        uploadedFiles,
        handleDrop,
        removeFile,
        clearFiles,
        setUploadedFiles
    };
};
